import React from "react";
import Dict from 'dict-lib';
import {Button, ButtonGroup, ButtonToolbar, Col, Grid, Modal, Row, Label} from 'react-bootstrap';
import ReactDOM from "react-dom";
import BUtils from './../../utilities/BaseUtilities';
import stylesScNavbar from './../../dict-components/navbar/ScNavbar.module.css';
import stylesSearchMenu from "../../_css/dictionary/searchMenu.module.css";
import {SCRadiobutton} from "../../dict-components/radiobutton/SCRadiobutton";
import {LexemeUtilities} from "../../lexeme/page/editor/LexemeHelper";
import {AdministrationUtilities} from "../../administration/AdministrationHelper";


export class LexemeExport extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            show: true,
            components: [],
            langAlphabet: {label: 'scegli una lingua', value: '', selected: [], count: {tot: 0}},
            exportInfos: {status: 'STOP', percent: '', buttonName: 'AVVIA', files: {}},
            consultChar: 'a',
            exportOpen: true
        };

        this.scItems = Dict.getVarious('root_languages').filter((langItem) => {
            return langItem.is_active === true;
        }).map((item) => {
            return {label: item.label, code: item.id + ''};
        });
    }

    _setLanguageAlphabet() {
        Dict.call('language/getLanguageData/' + this.state.langAlphabet.id + '/ALPHABET/').then((result) => {
            var langAlphabet = this.state.langAlphabet;
            langAlphabet.value = result.dataObject.alphabet;
            langAlphabet.selected = [];
            this.setState({langAlphabet});
        });
    }

    _setLanguageAlphabetCharToExport(char) {
        if (this.state.exportInfos.status === 'STOP') {
            var langAlphabet = this.state.langAlphabet;
            var selected = langAlphabet.selected;
            var index = selected.indexOf(char);

            if (char === 'ALL') {
                if (selected.length > 0)
                    langAlphabet.selected = [];
                else {
                    langAlphabet.selected = (langAlphabet.value.split('-'));
                }
            } else {
                if (index === -1) {
                    langAlphabet.selected.push(char);
                } else {
                    langAlphabet.selected.splice(index, 1);
                }
            }

            langAlphabet.selected.sort();

            if (langAlphabet.selected.length > 0) {
                Dict.call('concurrentServices/countExportDictionary/' + langAlphabet.id + '/' + langAlphabet.selected + '/').then((result) => {
                    langAlphabet.count = result;
                    this.setState({langAlphabet});
                });
            } else {
                langAlphabet.count = 0;
                this.setState({langAlphabet});
            }
        }
    }

    _close() {
        this.setState({show: false}, () => {
            this._stopCheck();
            setTimeout(function () {
                ReactDOM.unmountComponentAtNode(document.getElementById("dict-modal-container"));
            }, 200);
        });
    }

    _resetExport() {
        var langAlphabet = {
            label: this.state.langAlphabet.label,
            id: this.state.langAlphabet.id,
            value: this.state.langAlphabet.value,
            selected: [],
            count: {tot: 0}
        };
        var exportInfos = {status: 'STOP', percent: '', buttonName: 'AVVIA', filename: '', files: {}};

        this.setState({langAlphabet, exportInfos});
    }

    _startExport(indexChar) {
        this._unmountExportContainer();
        var exportInfos = this.state.exportInfos;
        exportInfos.status = 'START';
        exportInfos.buttonName = 'AVVIATO';
        var consultChar = this.state.langAlphabet.selected[0];
        this.setState({exportInfos, consultChar}, () => {
            const charSplit = this.state.langAlphabet.selected;
            const charExport = charSplit[indexChar];
            this._performStartExport(this.state.langAlphabet.id, charExport, 0, this.state.langAlphabet.count[charExport], [], (result) => {
                if (indexChar === (charSplit.length - 1)) {
                    exportInfos.status = 'FINISH';
                    exportInfos.buttonName = 'RESET';
                    exportInfos.percent = '';

                    exportInfos.files.zipFile = result.zipFile;
                    exportInfos.files.htmlFile = result.htmlFile;
                    exportInfos.files.jsonFile = result.jsonFile;
                    this.setState({exportInfos});

                    this._unmountExportContainer();

                    this._consultByChar();
                } else {
                    this._startExport(++indexChar);
                }
            });
        });
    }

    _unmountExportContainer() {
        var exportContainer = document.getElementById('export-result-container');
        var lexemePages = exportContainer.getElementsByClassName('lexeme-page');
        if (lexemePages.length > 0) {
            var container = exportContainer.getElementsByClassName('lexeme-page')[0].parentNode;
            ReactDOM.unmountComponentAtNode(container);
        }

        exportContainer.innerHTML = '';
    }

    _performStartExport(langId, chars, index, tot, components, callback) {
        Dict.call('concurrentServices/exportDictionary/' + langId + '/' + chars + '/' + index + '/' + tot + '/').then((result) => {
            var exportInfos = this.state.exportInfos;
            exportInfos.percent = chars + ' - ' + result.percent + "%";

            components = components.concat(result.json);
            if (result.percent === 100) {

                var counter = 1;
                var renderedComponents = [];
                for (const component of components) {
                    renderedComponents.push(LexemeUtilities.exportPage(component, counter++));
                    if (counter === 21)
                        break;
                }

                ReactDOM.render(renderedComponents, document.getElementById('export-result-container'));

                var res = '';
                var css = document.getElementsByTagName('style');
                for (let styleItem of css) {
                    res += styleItem.outerHTML;
                }

                var html = '<html><head><meta charset="UTF-8">' + res + '</head>' + document.getElementById('export-result-container').innerHTML + '</html>';

                Dict.call('/concurrentServices/saveHtmlExportFile/' + chars + '/', {
                    method: 'POST',
                    data: html,
                    headers: {}
                }).then((result) => {
                    callback(result);
                });


            } else {
                index = (parseFloat(index) + 20) + "";
                this.setState({exportInfos});
                return this._performStartExport(langId, chars, index, tot, components, callback);
            }


        });
    }

    _retrieveCharsByStatus() {
        const status = this.state.exportInfos.status;
        if (typeof this.state.langAlphabet.id === 'undefined') {
            return '';
        } else if (status === 'STOP' || status === 'START') {
            return ' lettere: ' + this.state.langAlphabet.selected.join(('-'));
        } else if (status === 'FINISH') {
            return <><span
                style={{marginRight: '4px'}}>Consulta:</span>{this.state.langAlphabet.selected.map((consultChar) => {
                return <Button bsStyle={consultChar === this.state.consultChar ? 'primary' : 'default'} onClick={() => {
                    this.setState({consultChar}, () => {
                        this._consultByChar();
                    });
                }
                }>{consultChar}</Button>;
            })}</>;
        }
    }

    _downloadFile(type) {
        var url = BUtils.getServerUrl() + '/concurrentServices/downloadExportFile/' + this.state.consultChar + '/' + type + '/';
        var a = document.createElement('a');
        a.href = url;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }


    _consultByChar() {

        Dict.call('concurrentServices/readExportHtml/' + this.state.consultChar + '/').then((result) => {
            document.getElementById('export-result-container').innerHTML = result.html;

            var pages = document.getElementById('export-result-container').getElementsByClassName('lexeme-page');

            for (const page of pages) {
                page.style.display = 'block';
            }
        });
    }


    render() {

        var exportButtons = [];
        const langSelected = Object.keys(this.state.langAlphabet.value).length > 0;
        const charSelected = this.state.langAlphabet.selected.length > 0;
        const isStart = this.state.exportInfos.status === 'START';
        const isStop = this.state.exportInfos.status === 'STOP';

        if (langSelected) {
            var allButton = [<Button style={{width: '73px', paddingLeft: '8px'}} onClick={() => {
                this._setLanguageAlphabetCharToExport('ALL');
            }
            }>{Dict.t('COMPLETE_EXPORT')}</Button>];
            exportButtons = this.state.langAlphabet.value.split('-').map((char) => {
                const style = this.state.langAlphabet.selected.indexOf(char) >= 0 ? 'success' : 'default';
                return <Button bsStyle={style} onClick={() => {
                    this._setLanguageAlphabetCharToExport(char);
                }
                }>{char.toUpperCase()}</Button>;
            });

            exportButtons = allButton.concat(exportButtons);
        }

        var additionalCharSelected = stylesScNavbar['lexeme-pages-generator-export-row-chars-infos--' + charSelected];
        var classInfos = BUtils.joinClasses(stylesScNavbar['lexeme-pages-generator-export-row-chars-infos'], additionalCharSelected);
        var startInfos = BUtils.joinClasses(stylesScNavbar['lexeme-pages-generator-export-row-chars-start'], additionalCharSelected);


        return <Modal show={this.state.show} dialogClassName={stylesScNavbar['lexeme-pages-export-dialog-modal']}
                      restoreFocus onHide={() => this._close()}>
            <Modal.Header closeButton><h4 className={'modal-title'}>Esportazione dei lessemi</h4></Modal.Header>
            <Modal.Body>
                <Row
                    className={stylesScNavbar['lexeme-pages-export-row-cols-modal--' + this.state.exportOpen]}>
                    <SCRadiobutton key={"key-radio-languages"} bsStyle="primary"
                                   id={'dict-languages'}
                                   items={this.scItems.map((scItem) => {
                                       if (!isStop && scItem.code !== this.state.langAlphabet.id) {
                                           scItem.disabled = true;
                                       } else
                                           scItem.disabled = undefined;
                                       return scItem;
                                   })}
                                   additionalClass={BUtils.joinClasses(stylesSearchMenu['dict-languages-radio'], stylesSearchMenu['vertical-dict-languages-radio'])}
                                   default={this.state.langAlphabet.id}
                                   callbackParent={(newState) => {
                                       if (isStop) {
                                           var langAlphabet = this.state.langAlphabet;
                                           langAlphabet.id = newState;
                                           langAlphabet.langName = this.scItems.find((scItem) => {
                                               return scItem.code === newState;
                                           }).label;
                                           this.setState({langAlphabet}, () => {
                                               this._setLanguageAlphabet();
                                           })
                                       }
                                   }}/>
                    <div className={stylesScNavbar['lexeme-pages-generator-export-row-chars']}>
                        {typeof this.state.langAlphabet.id === 'undefined' ? '' : exportButtons}
                    </div>
                </Row>
                <Row>
                    <div className={stylesScNavbar['lexeme-pages-generator-export-row-chars-infos-container']}>
                        <div className={stylesScNavbar['lexeme-pages-generator-export-row-chars-buttonbar']}/>
                        {this.state.exportInfos.status === 'FINISH' && this.state.langAlphabet.selected.length > 1 ?
                            <div className={classInfos}>
                                {this._retrieveCharsByStatus()}
                            </div> : ''}
                        {this.state.exportInfos.status === 'FINISH' ? '' :
                            <div className={classInfos}>
                                {typeof this.state.langAlphabet.id === 'undefined' ? '' : 'tot:' + this.state.langAlphabet.count.tot}
                            </div>}
                        {!isStart ? '' : <div style={{width: '100px', textAlign: 'left', paddingLeft: '10px'}}
                                              className={classInfos}>{this.state.exportInfos.percent}</div>}
                        <div className={startInfos}>
                            {this.state.exportInfos.status === 'FINISH' ? <>
                                <span style={{
                                    fontSize: '18px',
                                    verticalAlign: 'middle',
                                    marginRight: '4px'
                                }}>Scarica:</span>
                                <Button bsSize="large"
                                        onClick={() => {
                                            this._downloadFile("html");
                                        }
                                        }>{'html'}</Button>
                                <Button bsSize="large"
                                        onClick={() => {
                                            this._downloadFile("json");
                                        }
                                        }>{'json'}</Button>
                                <Button bsSize="large"
                                        onClick={() => {
                                            this._downloadFile("zip");
                                        }
                                        }>{'entrambi'}</Button>
                            </> : ''}
                            {typeof this.state.langAlphabet.id === 'undefined' || isStart ? '' :
                                <Button style={{marginLeft: '15px'}} onClick={() => {
                                    var status = this.state.exportInfos.status;
                                    if (status === 'FINISH')
                                        this._resetExport();
                                    else {
                                        Dict.call('/admin/clearTmpFolder/').then((result) => {
                                            this._startExport(0);
                                        });
                                    }
                                }}>{this.state.exportInfos.buttonName}</Button>
                            }
                        </div>
                    </div>
                    <div><div id={'export-result-container'} className={stylesScNavbar['export-result-container']}/></div>
                </Row>
            </Modal.Body>
        </Modal>

    }
}